<header id="page-topbar" data-scroll-header>
    <div class="layout-width">
        <div class="navbar-header">
            <div class="d-flex">
                <!-- LOGO -->
                <div class="navbar-brand-box horizontal-logo">
                    <a href="javascript:void(0);" class="logo logo-dark">
                        <span class="logo-sm">
                            <img src="assets/images/logo-sm.png" alt="" height="22">
                        </span>
                        <span class="logo-lg">
                            <img src="assets/images/logo-dark.png" alt="" height="17">
                        </span>
                    </a>
                    <a href="javascript:void(0);" class="logo logo-light">
                        <span class="logo-sm">
                            <img src="assets/images/logo-sm.png" alt="" height="22">
                        </span>
                        <span class="logo-lg">
                            <img src="assets/images/logo-light.png" alt="" height="17">
                        </span>
                    </a>
                </div>
                <button type="button" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                    id="topnav-hamburger-icon" (click)="toggleMobileMenu($event)">
                    <span class="hamburger-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button>
            </div>

            <div class="d-flex align-items-center">
                <div class="dropdown d-md-none topbar-head-dropdown header-item" ngbDropdown>
                    <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                        id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false" ngbDropdownToggle>
                        <i class="bx bx-search fs-22"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                        aria-labelledby="page-header-search-dropdown" ngbDropdownMenu>
                        <form class="p-3">
                            <div class="form-group m-0">
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="{{'general_search' | translate}}"
                                        aria-label="Recipient's username">
                                    <button class="btn btn-primary" type="submit"><i
                                            class="mdi mdi-magnify"></i></button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="ms-1 d-sm-flex">
                    <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode" (click)="openSidebar()">
                        <i class="bx bx-cog fs-28"></i>
                    </button>
                </div>
                
            </div>
        </div>
    </div>
</header>


<!-- Sidebar Start -->
<div>
    <div class="sidebar-menus" [ngClass]="{'open': isSidebarOpen}">
        <div class="sidebar-header">
            <div class="logo-sidebar text-white fs-5">
                {{ 'Settings' | translate }}
            </div>
            <div>
                <button class="btn sidebar-btn" type="button" (click)="closeSidebar()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="white" class="bi bi-grid"
                        viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg>
                </button>
            </div>
        </div>

        <div class="sidebar-item">
            <div class="sidebar-profile">
                <div class="avtar-wrap">
                    <img src="assets/images/users/user-dummy-img.jpg" class="user" />
                </div>
                
                <h4 class="profilename">{{userData.first_name}} {{userData.last_name}}</h4>
                <h6 class="profiletitle">{{"User" | translate}}</h6>
            </div>
            <ul>
                <li class="sidebar-list">
                    <div class="side-left">{{'Language' | translate}}</div>
                    <div class="side-right">
                        <select class="form-select" [(ngModel)]="langValue" (change)="languageService.changeLang(langValue)">
                            <option *ngFor="let item of listLang; let i = index" [value]="item.lang">
                                <img [src]="item.flag" alt="flag" class="me-2 rounded" height="18">
                                {{ item.text }}
                            </option>
                        </select>
                    </div>
                    
                </li>
                
                <li class="sidebar-list">
                    <a class="side-left txt-link" href="javascript:void(0)"
                    (click)="adminProfile()">{{'Change Password' | translate}}</a>
                </li>
            </ul>

            <ul class="bottom">
                <li class="sidebar-list list-bg-dark">
                    <a class="txt-link d-wrap" href="javascript:void(0)"
                        (click)="logout()">{{'Logout'| translate}}
                     <span><i class="mdi mdi-logout fs-22"></i></span></a>
                </li>
            </ul>
        </div>
        <div class="sidebar-footer"><span>{{"Powered by" | translate}} WEBER RESCUE SYSTEMS</span> 
            <span>v{{applicationVersion}}</span></div>
    </div>
</div>
<!-- Sidebar End -->